import React, { Component } from "react";
import "./Videos.scss";
import { usingAPI } from "../Services/FetchService";
export default class Videos extends Component {
    constructor() {
        super();
        this.state = {
            Videos: []
        }
    }
    async componentDidMount() {
        this.setState({
            Videos: await usingAPI.getLatestVideos()
        })
    }
    render() {
        const { Videos } = this.state;
        if (Videos.length == 0) return (<div></div>);
        return (
            <section className="section section-videos">
                <div className="padding">
                    <div className="container">
                        <div className="headline">
                            בחירות בווידיאו - כתבות אחרונות
                        </div>
                        <div className="latest">
                            <div className="wrapper">
                                {(() => Videos.map((item, index) =>
                                    <div className="item" key={index}>
                                        <a href={item.Link} title={item.Title} target="_self">
                                            <div className="image" style={{
                                                backgroundImage: `url(${item.Image.source})`
                                            }}>
                                                <div className="play"></div>
                                            </div>
                                            <div className="desc">
                                                {item.Title}
                                            </div>
                                        </a>
                                    </div>
                                ))()}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Components/Videos/Videos.jsx